import { useCssVars as _useCssVars, unref as _unref, defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = ["href"]
const _hoisted_2 = {
  key: 0,
  "aria-hidden": "true",
  class: "ml-2"
}

import type { PrimaryButtonProps } from "./PrimaryButtonProps";


export default /*@__PURE__*/_defineComponent({
  __name: 'PrimaryButton',
  props: {
    href: {},
    label: {},
    textColor: {},
    backgroundColor: {},
    showArrow: { type: Boolean, default: false }
  },
  setup(__props: any) {

_useCssVars(_ctx => ({
  "3f6707be": (_ctx.backgroundColor),
  "abbec6fc": (_ctx.textColor)
}))



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("a", {
    href: _ctx.href,
    class: "inline-flex items-center"
  }, [
    _createTextVNode(_toDisplayString(_ctx.label) + " ", 1),
    (_ctx.showArrow)
      ? (_openBlock(), _createElementBlock("span", _hoisted_2, "→"))
      : _createCommentVNode("", true)
  ], 8, _hoisted_1))
}
}

})